// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewClanBattles_wrapper_a78ee","tabsNavigation":"ViewClanBattles_tabsNavigation_fdb58","gold":"ViewClanBattles_gold_c6743","tabs":"ViewClanBattles_tabs_dc3fb"};